module.exports = __webpack_public_path__ + "static/media/quick-logo.dc5ed881.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/assets/logos/genesisbm/quick-logo.svg
// module id = 751
// module chunks = 0